export default {
	AUTOCOMPLETE: 'autocomplete',
	TEXT: 'text',
	NUMBER: 'number',
	PASSWORD: 'password',
	TEXTAREA: 'textarea',
	RADIO: 'radio',
	DATE: 'date',
	DATE_2: 'date2',
	MULTISELECT: 'multiselect',
	SELECT: 'select',
	SELECT_OBJECT: 'selectObject',
	PLAIN: 'plain',
	CHECKBOX: 'checkbox',
	HIGHLIGHTABLE_INPUT: 'highlightableInput'
};